// src/pages/RecoverPasswordPage.tsx
import React, { useState } from "react";
import { resetPassword, type ResetPasswordState } from "../api/authService";
import { useNavigate } from "react-router-dom";
import "../styles/auth.css";

export default function RecoverPasswordPage() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<ResetPasswordState>({ status: "idle" });
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setState({ status: "loading" });
    const result = await resetPassword(email);
    setState(result);
  };

  const resetState = () => setState({ status: "idle" });

  return (
    <>
    <div className="top-bar" />
    <div className="auth-container1">
        <h2>Recuperar contraseña</h2>

        <form onSubmit={handleSubmit}>
            <input
            type="email"
            placeholder="Introduce tu correo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={state.status === "loading"}
            />

            <button type="submit" disabled={state.status === "loading"}>
            {state.status === "loading" ? "Enviando..." : "Restablecer contraseña"}
            </button>
        </form>

        {state.status === "success" && (
            <p className="success-msg">{state.message}</p>
        )}
        {state.status === "error" && <p className="error-msg">{state.message}</p>}

        <button onClick={() => navigate("/login")} className="link-btn">
            Volver al inicio de sesión
        </button>
    </div>
    </>
  );
}
